import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject, Subject, EMPTY } from 'rxjs';

@Injectable()
export class CppAddProductSliderModelService {
  public addCppProductSlider: BehaviorSubject<boolean>;
  public cppsidenav: MatSidenav;
  private activeSliderValue: string;
  cppSliderCloseRqt: Subject<boolean>;
  cppModelData: BehaviorSubject<any>;
  public shipToOrDeliverToAccount: number;
  public shipToAccountNumber: number;
  public soldToAccountNumber: number;
  public isCustomerPickup: boolean;

  constructor() {
    this.addCppProductSlider = new BehaviorSubject(false);
    this.cppModelData = new BehaviorSubject(EMPTY);
    this.cppSliderCloseRqt = new Subject();
  }

  activeSlider(value: string) {
    this.activeSliderValue = value;

    if (value === 'AddCppProductSlider') {
      this.addCppProductSlider.next(true);
      this.cppModelData.next(EMPTY);
      this.cppsidenav.toggle();
    }
  }

  public SetCppSideNav(cppSideNavObj: MatSidenav) {
    this.cppsidenav = cppSideNavObj;
  }

  public cppClose() {
    this.cppModelData.next(EMPTY);
    this.addCppProductSlider.next(false);
    this.cppsidenav.close();
  }

  public setData<T>(obj: T) {
    this.cppModelData.next(obj);
  }

  public setRequestData<T>(obj: T) {
    this.cppModelData.next(obj);
  }
}
